﻿import { mutations } from "@/graphql";
import { useState } from "react";
import { useMutation } from "@apollo/client/react";
export const useAddPartner = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addPartner, { loading, data }] = useMutation<any>(
    mutations.addPartner,
    {
      onCompleted: (response) => {
        if (response.addPartner?.success) {
          setSuccess(true);
          setResetForm(true);
          setTimeout(() => {
            setSuccess(false);
            setResetForm(false);
          }, 5000);
          onCompleted();
        } else {
          setSuccess(false);
        }
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
      },
    },
  );
  return {
    addPartner,
    loading,
    success,
    data,
    resetForm,
  };
};
